import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';

const Happy = () => {
  return (
      <EmojiEmotionsIcon style={{
          flexGrow: '1', 
          marginTop: '10px', 
          postion: 'absolute', 
          width: '10vh',
          height: '10vh',
          verticalAlign: 'middle'
       }}/>
  )
}

export default Happy;